import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Breadcrumb, VapImage, FlexBox } from '@quikr/ui';
import { extractImgUrl, getLocalStorage } from '@quikr/ui/src/helpers/common';
import TopFeature from '@quikr/ui/src/common/TopFeature';
import { getAction } from '../../../helpers/action';
import { useGa } from '../../../hooks';
import SubHeader from '../../common/SubHeader';
import VapHomesExtrainfo from '../HomesExtrainfo';
import VapInfo from '../VapInfo';

const AndroidDownloadPopup = loadable(() => import('../AndroidDownloadPopup'), { ssr: false });
const AndroidRedirectModal = loadable(() => import('../AndroidRedirectModal'), { ssr: false });
const VapLoadables = loadable(() => import('../VapLoadables'), { ssr: false });
const ContactForm = loadable(() => import('../ContactForm'), { ssr: false });
const MobileGallery = loadable(() => import('@quikr/ui/src/common/MobileGallery'), { ssr: false });
const DesktopGallery = loadable(() => import('@quikr/ui/src/common/Gallery'), {
  ssr: false
});
const ChatForm = loadable(() => import('../ChatForm'), { ssr: false });
const AutoFLP = loadable(() => import('./AutoFLP'), { ssr: false });

const VapHomes = ({ data: { ad: adData, abRandValue, isAndroid, isMobile, user } = {} }) => {
  const [source, setSource] = useState('contact');
  const [showGallery, setshowGallery] = useState(false);
  const [androidDownloadPopup, setAndroidDownloadPopup] = useState({
    commonRedirectionGA: () => {},
    show: false,
    title: '',
    description: '',
    redirectOnClose: false,
    redirectUrl: '',
    isForQApp: false
  });
  const [androidRedirectModal, setAndroidRedirectModal] = useState({
    commonRedirectionGA: () => {},
    show: false,
    action: ''
  });
  const [showCallModal, setShowCallModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const { TriggerGaEvent } = useGa();
  const loggedIn = Boolean(user);
  const {
    images = [],
    adstyle,
    alttitle,
    title,
    // user: adOwner,
    cat,
    subcat,
    city,
    breadcrumbs = [],
    price,
    actions,
    features = []
  } = adData;
  const galleryImages = [];
  const vapImages = images.map((image, index, obj) => {
    galleryImages.push(extractImgUrl(image, 'lg'));
    if (isMobile) {
      return extractImgUrl(image, 'nr');
    } else {
      if (Object.keys(obj).length >= 5) {
        if (index < 2) {
          return extractImgUrl(image, 'nr');
        }
        return extractImgUrl(image, 'gv');
      }
      return extractImgUrl(image);
    }
  });

  const getGalleryImages = (isVapImg = false) => {
    const { galleryImages: images } = adData;
    if (isVapImg) {
      return images
        ? images.reduce(
          (acc, each) => {
            acc.push(...each.images);
            return acc;
          },
          [...vapImages]
        )
        : vapImages;
    }
    if (images && images.length > 0) {
      const Img = {
        images,
        isTabsDisplay: true
      };
      if (galleryImages.length > 0) {
        Img.images = [
          {
            tab: 'Property Images',
            images: galleryImages
          },
          ...images
        ];
      }
      return Img;
    } else {
      return {
        images: galleryImages,
        isTabsDisplay: false
      };
    }
  };

  useEffect(() => {
    const Action = getAction().toLowerCase();
    if (Action) {
      switch (Action) {
        case 'contact':
        case 'autopopup':
          setSource(Action);
          setShowCallModal(true);
          break;
        case 'chat':
          setShowChatModal(true);
          break;
        case 'whatsapp':
          setShowWhatsappModal(true);
          break;
        default:
          break;
      }
    }
  }, []);

  // 23 - Bangalore
  // all but ios
  const tempRedirect = false; // ['23'].includes(city.id) && (isAndroid || !isMobile);

  useEffect(() => {
    const reContactTS = getLocalStorage('_re_contact_ts');
    const now = new Date().getTime();
    const daysDiff = reContactTS ? (now - reContactTS) / (1000 * 60 * 60 * 24) : 7;
    let timeoutHandle = null;
    if (daysDiff >= 7) {
      timeoutHandle = setTimeout(() => {
        if (!showCallModal && !showChatModal && !showWhatsappModal && !tempRedirect) {
          setSource('autopopup');
          setShowCallModal(true);
          fireVAPGa('requirement_popUp_init');
        }
      }, 30000);
    }

    return () => {
      clearTimeout(timeoutHandle);
    };
  }, []);

  const handleTempRedirection =
    tempRedirect &&
    (action => {
      setAndroidRedirectModal({
        commonRedirectionGA: () => fireVAPGa(`QH_${action}_app_redirect`),
        show: true,
        action
      });
    });

  const toggleGallery = value => {
    const vapImgs = getGalleryImages();
    if (vapImgs.images.length > 0) {
      setshowGallery(value);
    }
  };

  const handleCallToggle = () => {
    !showCallModal && setSource('contact');
    setShowCallModal(!showCallModal);
    if (!showCallModal && showGallery) fireVAPGa('galleryCtaSection_call_init', 'Gallery');
  };

  const handleChatToggle = () => {
    setShowChatModal(!showChatModal);
    if (!showChatModal && showGallery) fireVAPGa('galleryCtaSection_chat_init', 'Gallery');
  };

  const handleWhatsappToggle = () => {
    setShowWhatsappModal(!showWhatsappModal);
    if (!showWhatsappModal && showGallery) fireVAPGa('galleryCtaSection_Whatsapp_init', 'Gallery');
  };

  const fireVAPGa = (eventLabel, eventCat = 'VAP') => {
    TriggerGaEvent({
      category: eventCat,
      label: eventLabel,
      cityName: city.name,
      catName: cat.name,
      subcatName: subcat.name
    });
  };

  // 152222 - Jaipur, 22 - Ahmedabad
  const allowRedirectionToQApp = isMobile && isAndroid && abRandValue <= -1;
  const handleRedirectionToQApp =
    allowRedirectionToQApp &&
    (action => {
      setAndroidDownloadPopup({
        commonRedirectionGA: () => fireVAPGa(`QAPP_VAP_${action}_REDIRECT`),
        description: 'Download Our App to Respond to Ads',
        isForQApp: true,
        show: true,
        redirectOnClose: true,
        redirectUrl: `https://play.google.com/store/apps/details?id=com.quikr&utm_source=VAP_${action.toLowerCase()}&utm_campaign=QAPP_VAP_REDIRECT&utm_medium=${cat.name.replaceAll(
          /\s+/g,
          '_'
        )}`,
        title: 'Quikr is Better on App!'
      });
    });

  const gutter = isMobile ? 12 : 20;
  return (
    <>
      {!isMobile && <SubHeader city={city} />}
      {loggedIn && (
        <AutoFLP
          city={city}
          adId={adData.id}
          fireGa={fireVAPGa}
          propertyType={adData.propertytype}
        />
      )}
      <FlexBox.Row margin={gutter}>
        <FlexBox.Column md={7} sm={7} xs={12} gutterWidth={gutter}>
          {!isMobile && <Breadcrumb data={breadcrumbs} />}
          <VapImage
            images={getGalleryImages(true)}
            isMobile={isMobile}
            adType={adstyle}
            title={alttitle || title}
            openGallery={toggleGallery}
          />
          {isMobile && (
            <VapInfo
              data={adData}
              openCall={handleCallToggle}
              openChat={handleChatToggle}
              openWhatsapp={handleWhatsappToggle}
              redirectToQApp={handleRedirectionToQApp}
              tempRedirect={handleTempRedirection}
            />
          )}
          {!isMobile && <TopFeature features={features} />}
          <VapHomesExtrainfo data={adData} top={isMobile ? 91 : 140} />
          <VapLoadables
            type="Primary"
            adData={adData}
            userId={String(adData.user.id)}
            fireGa={fireVAPGa}
          />
        </FlexBox.Column>
        {!isMobile && (
          <FlexBox.Column md={5} sm={5} hiddenXs gutterWidth={20}>
            <VapInfo
              data={adData}
              openCall={handleCallToggle}
              openChat={handleChatToggle}
              openWhatsapp={handleWhatsappToggle}
              redirectToQApp={handleRedirectionToQApp}
              tempRedirect={handleTempRedirection}
            />
          </FlexBox.Column>
        )}
      </FlexBox.Row>
      {androidDownloadPopup.show && (
        <AndroidDownloadPopup
          commonRedirectionGA={androidDownloadPopup.commonRedirectionGA}
          description={androidDownloadPopup.description}
          city={city}
          isForQApp={androidDownloadPopup.isForQApp}
          onClose={() => setAndroidDownloadPopup(prev => ({ ...prev, show: false }))}
          redirectOnClose={androidDownloadPopup.redirectOnClose}
          redirectUrl={androidDownloadPopup.redirectUrl}
          showPopup={androidDownloadPopup.show}
          title={androidDownloadPopup.title}
          fireGa={fireVAPGa}
        />
      )}
      {androidRedirectModal.show && (
        <AndroidRedirectModal
          action={androidRedirectModal.action}
          commonRedirectionGA={androidRedirectModal.commonRedirectionGA}
          onClose={() => setAndroidRedirectModal(prev => ({ ...prev, show: false }))}
          showPopup={androidRedirectModal.show}
          fireGa={fireVAPGa}
          isAndroid={isAndroid}
          isMobile={isMobile}
        />
      )}
      {showCallModal && (
        <ContactForm
          title={actions.top[0].replace('_', ' ')}
          onClose={handleCallToggle}
          cat={cat}
          fireGa={fireVAPGa}
          subcat={adData.subcat}
          source={source}
        />
      )}
      {showGallery &&
        (isMobile ? (
          <MobileGallery
            close={toggleGallery}
            galleryImages={getGalleryImages()}
            title={alttitle || title}
            price={price}
            actions={actions.gallery}
            openCall={handleCallToggle}
            openChat={handleChatToggle}
            openWhatsapp={handleWhatsappToggle}
            redirectToQApp={handleRedirectionToQApp}
            tempRedirect={handleTempRedirection}
          />
        ) : (
          <DesktopGallery
            close={toggleGallery}
            galleryImages={getGalleryImages()}
            title={alttitle || title}
            price={price}
            actions={actions.gallery}
            openCall={handleCallToggle}
            openChat={handleChatToggle}
            openWhatsapp={handleWhatsappToggle}
            tempRedirect={handleTempRedirection}
          />
        ))}
      {showChatModal && <ChatForm adData={adData} onClose={handleChatToggle} fireGa={fireVAPGa} />}
      {showWhatsappModal && (
        <ContactForm
          title="Whatsapp"
          onClose={handleWhatsappToggle}
          cat={cat}
          fireGa={fireVAPGa}
          subcat={adData.subcat}
        />
      )}
    </>
  );
};

VapHomes.propTypes = {
  data: PropTypes.object,
  staticContext: PropTypes.object
};

VapHomes.defaultProps = {};

export default VapHomes;
